import { Link } from 'gatsby'
import { ReactComponent as Logo } from '../../images/header/logo_colored.svg'
import React from 'react'

const TagLogo = () => (
  <Link
    data-testid="logo-anchor"
    to="/"
  >
    <Logo />
  </Link>
)

export default TagLogo
